import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'antd';
import { deleteDeviceApi, getMyDevices } from '../../redux/sign-in/apiRoute';
import { toast } from 'react-toastify';
import styled from '@emotion/styled';
import { ModalCloseBox } from '../../modules/employees/EmployeesStyle';
import { LogoutNewIcon, ModalCloseIcon } from '../../theme/SvgIcons';
import PropTypes from 'prop-types';
import ConfirmationModal from '../Modal/ConfirmationModal';
import { FlexWrapper } from '../../theme/common_style';

const ActiveDevices = ({ open, onClose }) => {
  const [devices, setDevices] = useState([]);
  const [loading, setLoading] = useState(false);

  const [deleteDevice, setDeleteDevice] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);

  const handleDeviceLogout = async () => {
    setDeleteLoading(true);
    try {
      let res = await deleteDeviceApi({ deviceId: deleteDevice?.id });
      if (res?.statusCode === 200) {
        toast.success(res?.message || 'Device logged out successfully');
        handleDevice();
        setDeleteDevice(null);
      }
    } catch (error) {
      toast.error(error?.message || 'Something went wrong');
    } finally {
      setDeleteLoading(false);
    }
  };

  const handleDevice = async () => {
    setLoading(true);
    try {
      let res = await getMyDevices();
      if (res?.statusCode === 200) {
        setDevices(res?.data);
      }
    } catch (error) {
      toast.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    handleDevice();
  }, []);

  const columns = [
    {
      title: 'Device',
      dataIndex: 'device',
      render: (_, __, index) => index + 1
    },
    {
      title: 'IP Address',
      dataIndex: 'ip_address',
      key: 'ip_address'
    },
    {
      title: 'Time Zone',
      dataIndex: 'time_zone',
      key: 'time_zone'
    },
    {
      title: 'Device Type',
      dataIndex: 'device_type',
      key: 'device_type'
    },
    {
      title: 'User Agent',
      dataIndex: 'user_agent',
      key: 'user_agent'
    },
    {
      title: 'Action',
      dataIndex: 'action',
      key: 'action',
      render: (_, record) => {
        return (
          <FlexWrapper
            style={{ cursor: 'pointer' }}
            onClick={() => setDeleteDevice({ isOpen: true, id: record?.id })}>
            <LogoutNewIcon color="#fff" />
          </FlexWrapper>
        );
      }
    }
  ];

  return (
    <Modal
      open={open}
      onCancel={onClose}
      prefixCls="create-employees"
      width="500"
      centered
      closeIcon={false}
      footer={null}>
      <ModalCloseBox onClick={onClose}>
        <ModalCloseIcon />
      </ModalCloseBox>
      <ContentBox>
        <h4>Active Devices</h4>
        <Table
          prefixCls="antCustomTable"
          dataSource={devices}
          columns={columns}
          rowKey={(record) => record.id}
          pagination={false}
          loading={loading}
        />
      </ContentBox>
      {deleteDevice?.isOpen && (
        <ConfirmationModal
          open={deleteDevice?.isOpen}
          onCancel={() => setDeleteDevice(null)}
          title="Logout"
          onSubmit={handleDeviceLogout}
          buttonName="Yes"
          description="Are you sure you want to logout this device?"
          iconBG="#FB4A49"
          loading={deleteLoading}
        />
      )}
    </Modal>
  );
};

export default ActiveDevices;

ActiveDevices.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func
};

const ContentBox = styled.div`
  width: 100%;
  padding: 24px;

  h4 {
    font-family: 'Plus Jakarta Sans';
    font-weight: 700;
    font-size: 24px;
    color: #0e0e0e;
    margin: 0;
    text-align: center;
  }
`;
